import React from 'react';
import styles from '../../styles/components/answers/TextFieldList.module.css';
import { TextField } from './TextField';
import _ from 'lodash';
import UUID from '@ax2/common/model/UUID';
import { BaseTextValidation } from '../../helpers/validationBuilder';

export interface TextFieldRecord {
  id: UUID;
  label: string | null;
  value: string | null;
  error?: string;
}

export interface TextFieldListData {
  options: TextFieldRecord[];
  validation?: BaseTextValidation;
  onCompletion: (options: TextFieldRecord[]) => void;
  key?: string;
}

export const TextFieldList: React.FC<TextFieldListData> = data => {
  const [inputsData, setInputsData] = React.useState<TextFieldRecord[]>(
    data.options
  );
  const errorOpt = _.find(inputsData, d => !!d.error);
  return (
    <div>
      <div className={styles.listContainer}>
        {inputsData.map((d, index) => {
          return (
            <TextField
              tabIndex={index + 1}
              key={index.toString()}
              value={d.value}
              error={d.error ? d.error : null}
              validation={data.validation}
              onCompletion={(v, e) => {
                const newInputsData = [...inputsData];
                newInputsData[index].value = v;
                newInputsData[index].error = e ? e : undefined;
                setInputsData(newInputsData);
                data.onCompletion(newInputsData);
              }}
            />
          );
        })}
      </div>
      {errorOpt && (
        <div className={styles.error}>
          <label>{errorOpt.error}</label>
        </div>
      )}
    </div>
  );
};
